import * as local from './local';
import * as supa from './supabase';

const configuredBackend = (import.meta as any).env?.VITE_INTAKE_BACKEND;
const backend = configuredBackend || ((import.meta as any).env?.PROD ? 'supabase' : 'local');

export const intakeStore = backend === 'supabase' ? supa : local;

export async function isIntakeBackendReady(): Promise<boolean> {
  try {
    if (backend === 'supabase') {
      const mod = await import('@/lib/supabase');
      return !!(mod && typeof mod.getSupabase === 'function' && mod.getSupabase());
    }
    return true;
  } catch {
    return false;
  }
}

// Re-export selected helpers for callers that need specific ops
export const markMerged = (packetId: string, clientId: string) => (intakeStore as any).markMerged(packetId, clientId);

// Convenience passthroughs used by provider finalize logic
export const getPacketByInvite = (inviteId: string) => (intakeStore as any).getPacketByInvite?.(inviteId);
export const getPacketById = (id: string) => (intakeStore as any).getPacketById?.(id);
export const listGoalDrafts = (packetId: string) => (intakeStore as any).listGoalsForPacket?.(packetId);
export const listTrackerDrafts = (packetId: string) => (intakeStore as any).listTrackerDrafts?.(packetId);
export const upsertTrackerDraft = (packetId: string, d: any) => (intakeStore as any).upsertTrackerDraft?.(packetId, d);
export const deleteTrackerDraft = (packetId: string, idOrTitle: string) =>
  (intakeStore as any).deleteTrackerDraft?.(packetId, idOrTitle);
export const reassignInvite = (packetId: string, newInviteId: string) =>
  (intakeStore as any).reassignInvite?.(packetId, newInviteId);
export const deleteAnswer = (packetId: string, section: string, key: string) =>
  (intakeStore as any).deleteAnswer?.(packetId, section, key);
export const upsertAnswer = (packetId: string, section: string, key: string, value: any) =>
  (intakeStore as any).upsertAnswer?.(packetId, section, key, value);
export const listAnswersForPacket = (packetId: string) => (intakeStore as any).listAnswersForPacket?.(packetId);
